import {
GET_CUSTOMER_REFUND_REQUEST,
GET_CUSTOMER_REFUND_SUCCESS,
GET_CUSTOMER_REFUND_ERROR
} from "../actions/types";

export default function (state = [], action) {
	const { type, payload } = action;
	switch (type) {
		case GET_CUSTOMER_REFUND_REQUEST:
			return {
				loading: true,
			};
		case GET_CUSTOMER_REFUND_SUCCESS:
			return {
				...state,
				loading: false,
				payload
			};
		case GET_CUSTOMER_REFUND_ERROR:
			return {
				...state,
				loading: false,
				payload,
			};

		default:
			return state;
	}
}
